/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import { metadata as dailyvideo__metadata_ts } from "./dailyvideo/_metadata";
import { metadata as googlevideo__metadata_ts } from "./googlevideo/_metadata";
import office365video_config_json from "./office365video/config.json";
import booking_pages_tag_config_json from "./templates/booking-pages-tag/config.json";
import event_type_location_video_static_config_json from "./templates/event-type-location-video-static/config.json";
import { metadata as zoomvideo__metadata_ts } from "./zoomvideo/_metadata";
export const appStoreMetadata = {
	dailyvideo: dailyvideo__metadata_ts,
	googlevideo: googlevideo__metadata_ts,
	office365video: office365video_config_json,
	"booking-pages-tag": booking_pages_tag_config_json,
	"event-type-location-video-static":
		event_type_location_video_static_config_json,
	zoomvideo: zoomvideo__metadata_ts,
};
